import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class FinalUserService {

  constructor(private http: HttpClient) { }

  getAllFinalUsersPaged(page, size): Observable<any> {
    return this.http.get(mainUrl + `final/paged?page=${page}&size=${size}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllFinalUsers(): Observable<any> {
    return this.http.get(mainUrl + `final`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllFinalUsersTwo(id): Observable<any> {
    return this.http.get(mainUrl + `final/final-users/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res)
      )
  }

  getFinalUserById(id): Observable<any> {
    return this.http.get(mainUrl + `final/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createFinalUser(form): Observable<any> {
    return this.http.post(mainUrl + 'final', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  editFinalUser(form, id): Observable<any> {
    return this.http.put(mainUrl + `final/${id}`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllUsersByFinalUserPaged(id, page, size): Observable<any> {
    return this.http.get(mainUrl + `final/users/paged/${id}?page=${page}&size=${size}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllUsersByFinalUser(id): Observable<any> {
    return this.http.get(mainUrl + `final/users/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteFinalUser(id): Observable<any> {
    return this.http.delete(mainUrl + `final/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createFinalUserUser(form): Observable<any> {
    return this.http.post(mainUrl + `final/user`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  editFinalUserUser(form, id): Observable<any> {
    return this.http.put(mainUrl + `final/user/${id}`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteFinalUserUser(id): Observable<any> {
    return this.http.delete(mainUrl + `final/user/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getFinalUserReport(): Observable<any> {
    return this.http.post(mainUrl + `final/users-report`, {}, { reportProgress: true, observe: 'response', responseType: 'blob' })
      .pipe(
        timeout(30000),
        map((res: any) => res.body)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
    });

    return headers;
  }
}
